import { useTimeClockStore } from '@/ShopManagement/stores/timeClock.js';

export {
  DEFAULT_TIME_CLOCK_TIME_ZONE,
  TimeClockError,
  entryMinutes,
  formatDate,
  formatMinutes,
  formatTime,
  timeTotals,
  toMinuteIso,
} from '@/ShopManagement/timeClockFormatters.js';

// The Time Clock state now lives in a Pinia store. New components should use
// `useTimeClockStore()` directly; it is re-exported here for convenience.
export { useTimeClockStore } from '@/ShopManagement/stores/timeClock.js';

export const TIME_CLOCK_ADAPTER_METHODS = Object.freeze([
  'ensureCurrentUser',
  'refreshFromServer',
  'setRecordsPageActive',
  'clockIn',
  'clockOut',
  'startBreak',
  'endBreak',
  'saveEntry',
  'requestCorrection',
  'requestMissingClock',
  'resolveReview',
  'employeeStatus',
  'managerSetEmployeeClock',
  'saveSettings',
  'refreshTodayWorkedMinutes',
]);

/**
 * Backwards-compatible facade over the Pinia Time Clock store.
 *
 * Existing Options-API components read `timeClockClient.state` and call the
 * methods below; both resolve the singleton store lazily (after Pinia is
 * installed). Prefer `useTimeClockStore()` in new code.
 */
export const timeClockClient = Object.freeze({
  get state() {
    return useTimeClockStore();
  },
  ensureCurrentUser: (...args) => useTimeClockStore().ensureCurrentUser(...args),
  refreshFromServer: (...args) => useTimeClockStore().refreshFromServer(...args),
  setRecordsPageActive: (...args) => useTimeClockStore().setRecordsPageActive(...args),
  clockIn: (...args) => useTimeClockStore().clockIn(...args),
  clockOut: (...args) => useTimeClockStore().clockOut(...args),
  startBreak: (...args) => useTimeClockStore().startBreak(...args),
  endBreak: (...args) => useTimeClockStore().endBreak(...args),
  saveEntry: (...args) => useTimeClockStore().saveEntry(...args),
  requestCorrection: (...args) => useTimeClockStore().requestCorrection(...args),
  requestMissingClock: (...args) => useTimeClockStore().requestMissingClock(...args),
  resolveReview: (...args) => useTimeClockStore().resolveReview(...args),
  employeeStatus: (...args) => useTimeClockStore().employeeStatus(...args),
  managerSetEmployeeClock: (...args) => useTimeClockStore().managerSetEmployeeClock(...args),
  saveSettings: (...args) => useTimeClockStore().saveSettings(...args),
  refreshTodayWorkedMinutes: (...args) => useTimeClockStore().refreshTodayWorkedMinutes(...args),
});
